import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.validateForm();
  }

  validateForm() {
    const pageLoginForm = $(this.element)

    if (pageLoginForm.length) {
      pageLoginForm.validate({
        rules: {
          'classroom_form[classroom_name]': {
            required: true
          }
        }
      });
    }
  }
}
